import { getModuleContent } from "@home/services/studio";
import { useEffect, useState } from "react";

export function useFactsData({ filter, gameInfo, sub_module, setMergedSubModuleData}: any) {
  const { date_type: dateType, start_time: startTime, end_time: endTime, game } = filter || {};

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [subModuleLoading, setSubModuleLoading] = useState(false);
  const [subModuleError, setSubModuleError] = useState(false);
  const [subModuleData, setSubModuleData] = useState([]);

  // 获取Facts 数据
  function getFactsData() {
    setLoading(true);
    setMergedSubModuleData([]);
    getModuleContent({
      system: "studio_hub",
      type: 2,
      uid_type: "unified_id,comp_unified_id",
      uid: `${gameInfo?.edition_unified_id},${game}`,
      period: dateType,
      start_time: startTime,
      end_time: endTime,
      module: "metrics_breakdown",
      status: 1,
    })
      .then((data: any) => {
        setData(data);
      })
      .catch((_error) => {
        setError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  // 获取subModule Facts 数据
  function getSubModuleFactsData(sub_module: string) {
    setSubModuleLoading(true);
    getModuleContent({
      system: "studio_hub",
      type: 2,
      uid_type: "unified_id,comp_unified_id",
      uid: `${gameInfo?.edition_unified_id},${game}`,
      period: dateType,
      start_time: startTime,
      end_time: endTime,
      module: "metrics_breakdown",
      sub_module,
      status: 1,
    })
      .then((data: any) => {
        setSubModuleData(data);
      })
      .catch((_error) => {
        setSubModuleError(true);
      })
      .finally(() => {
        setSubModuleLoading(false);
      });
  }

  useEffect(() => {
    if(sub_module){
      getSubModuleFactsData(sub_module);
    }
    else{
      getFactsData();
    }
  }, [filter, gameInfo, sub_module]);

  return {
    factsData: data,
    factsLoading: loading,
    factsError: error,
    refreshFactsData: getSubModuleFactsData,
    subModuleLoading,
    subModuleError,
    subModuleData,
  };
}
